<div
  class="mib-modal md:min-w-200 p-8 max-lg:landscape:p-4 flex flex-col gap-8 max-lg:landscape:gap-4"
  role="dialog">
  <header class="shrink-0 flex justify-between items-center">
    <mai-mib-logo></mai-mib-logo>
    <mib-button theme="secondary" mode="flat" size="large" (click)="dialogRef.close()">
      <svg mib-close-icon></svg>
    </mib-button>
  </header>

  <div class="shrink-0 flex max-md:flex-col text-gray-500 text-sm">
    @for (tab of tabs; track tab.file) {
      <div
        class="min-h-9 px-4 py-2 max-md:border-l md:border-b border-gray-200 cursor-pointer transition-colors flex items-center"
        [class.border-mib-primary]="currentTab() === tab.file"
        [class.md:border-b-2]="currentTab() === tab.file"
        [class.max-md:border-l-2]="currentTab() === tab.file"
        [class.text-mib-primary]="currentTab() === tab.file"
        (click)="selectTab(tab)">
        {{ tab.title }}
      </div>
    }
  </div>

  <div #tabContent class="mib-scrollbar overflow-y-auto min-h-0 flex-1 pr-4">
    <markdown ngPreserveWhitespaces class="markdown" [src]="currentTab()" (error)="onError($event)">
    </markdown>
  </div>
</div>
